import { ErrorCodes, FormDataKeys, RouteErrorJsonResponse, RouteFunctionJsonResponse } from "@cervval.js/common-routes";
import { anyReallyAny } from "@cervval.js/common/tools";
import { AbstractClientRoutesService } from "./abstract.clientRoutes.service";
import { ClientRouteOptions, CredentialsPolicy, RequestParameters } from "./clientRoutes.service";

/**
 * ClientRoutesService using XMLHttpRequest
 */
export class XhrClientRoutesService extends AbstractClientRoutesService {

    constructor(options?: ClientRouteOptions) {
        super(options);
        if (!window["XMLHttpRequest"]) {
            throw new Error("The browser does not support XMLHttpRequest");
        }
    }

    /**
     * Executes the request (no error handling)
     */
    protected _callImpl(request: RequestParameters, options?: { timeoutMs?: number, urlPrefix?: string, fileList?: Blob[] | FileList }): Promise<{ responseStatus: number, reply: RouteFunctionJsonResponse | RouteErrorJsonResponse | undefined }> {
        return new Promise((resolve, reject) => {
            const urlPrefix = options?.urlPrefix ?? this._options?.urlPrefix ?? "";// request options prevails on global options
            const url = urlPrefix + request.url;

            const xhr = new XMLHttpRequest();
            xhr.onload = function () {
                resolve({ responseStatus: xhr.status, reply: xhr.response });
            };
            xhr.onerror = function () {
                resolve({ responseStatus: xhr.status, reply: undefined });// we do not reject, we just have no reply
            };
            xhr.ontimeout = function () {
                resolve({ responseStatus: ErrorCodes.REQUEST_TIMEOUT, reply: undefined });// we do not reject, we just have no reply
            };

            xhr.open(request.method, url, true);
            xhr.responseType = "json";// server always returns json
            xhr.timeout = options?.timeoutMs ?? this._options?.timeoutMs ?? 0;// request options prevails on global options

            switch (this._options.withCredentials) {
                case CredentialsPolicy.ALWAYS:
                    xhr.withCredentials = true;
                    break;
                case CredentialsPolicy.ONLY_SAME:
                case CredentialsPolicy.NO:
                default:
                    xhr.withCredentials = false;
                    break;
            }

            if (options?.fileList?.length) {
                const formData = new FormData();
                // When use formData don't precise content type for request or get error missing boundary 

                for (let i = 0; i < options.fileList.length; i++) { // FileList is not iterable
                    const file = options.fileList[i]; // But a file in FileList can be accessed by the [] operator
                    formData.append(FormDataKeys.UPLOAD_FILES, file, file instanceof File ? file.name : undefined);
                }
                if (request.data != null) {
                    formData.append(FormDataKeys.FUNCTION_PARAMETERS, request.data as string);
                }

                xhr.send(formData);
            } else {
                xhr.setRequestHeader("Content-Type", request.contentType);
                xhr.send(request.data as anyReallyAny);// BGS : anyReallyAny should be BodyInit or XMLHttpRequestBodyInit but some versions of typescript typings trigger errors here
            }

        });
    }
}